import { render, staticRenderFns } from "./PlaceEditor.vue?vue&type=template&id=72998d7e&"
import script from "./PlaceEditor.vue?vue&type=script&lang=js&"
export * from "./PlaceEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports